import { _1_HOUR_IN_MS, buildChartDefs, drawWatermark, formatterDateTime, highchartColors } from "./generic_chart";
import { formatCurrency } from "../../util/currency";

export function buildChartConfig (data, element, vsCurrency) {
  return {
    legend: {
      enabled: true,
      layout: "horizontal",
    },
    exporting: false,
    rangeSelector: { enabled: false },
    scrollbar: { enabled: false },
    credits: { enabled: false },
    navigator: { enabled: false },
    time: { useUTC: true },

    tooltip: {
      useHTML: true,
      outside: true,
      borderRadius: 16,
      padding: 0.5,
      formatter() {
        let content = `<div class="title">${formatterDateTime.format(this.x)}</div>`;
        let pointSum = 0;
        let pointSumUsd = 0;

        // Loop through all y-axes and display in tooltip.
        this.points.forEach((point) => {
          pointSum += point.y;
          pointSumUsd += point.point.price;

          content += `<div><span style="color:${highchartColors[point.series.colorIndex]}"">\u25CF</span> ${point.series.name}: <span class="value">${formatCurrency(point.y, "", false, true, true)}</span> (${formatCurrency(point.point.price, vsCurrency, false, true, true)})</div>`;
        });

        content += `<div class="tw-mt-2 tw-border-gray-200 dark:tw-border-moon-700 tw-border-t tw-pt-2">
          <div>
            Total: <span class="value">${formatCurrency(pointSum, "", false, true, true)}</span> 
            (${formatCurrency(pointSumUsd, vsCurrency, false, true, true)})</div>
          </div>
        `;

        return content;
      }
    },

    xAxis: {
      minRange: _1_HOUR_IN_MS,
      type: "datetime",
      plotLines: [{
        color: "#FF0000",
        width: 2,
        value: Date.now(),
        dashStyle: "Dash",
        label: {
          useHTML: true,
          text: `<span class="tw-flex-grow tw-text-xs tw-leading-4 tw-text-gray-500 dark:tw-text-moon-200 tw-font-regular">Today</span>`,
          align: "left",
          rotation: 0,
          y: -4,
          x: -16
        },
        zIndex: 5
      }]
  },

    yAxis: {
      title: {
        text: null
      },
      showLastLabel: true,
      opposite: true,
      labels: {
        align: "left",
        reserveSpace: true,
        useHTML: true,
        formatter: function() {
          return formatCurrency(this.value, "", false,  false, true);
        },
      },
    },

    series: data.map((data, index) => {
      return {
        name: data.name,
        data: data.data,
        keys: ["x", "y", "price"],
        colorIndex: index % highchartColors.length,
        threshold: -Infinity,
        maxPointWidth: 250,
        boostThreshold: undefined,
        lineWidth: 1,
        marker: {
          enabled: false,
          radius: 0
        },
        states: {
          hover: {
            lineWidth: 1
          }
        },
        zoneAxis: "x",
        zones: [
          { value: Date.now(), className: "tw-opacity-100" },
          { className: "tw-opacity-80" },
        ]
      };
    }),

    plotOptions: {
      area: {
        stacking: "normal",
        lineWidth: 2,
        fillOpacity: 0.05,
        marker: {
          enabled: false
        }
      },
      series: {
        animation: false,
      }
    },

    chart: {
      events: { render: (e) => drawWatermark(e, true) },
      panning: false,
      marginTop: 50,
      renderTo: element.id,
      styledMode: true,
      zoomType: "x",
      type: "area",
    },

    ...buildChartDefs(),
  }
}
